module.exports = __webpack_public_path__ + "img/63a7c69872e999554158672aaa4ec8c9.png";